/**
 * Default code templates for the Gotti Sandbox.
 * 
 * Demonstrates a complete client-side prediction with server reconciliation netcode demo:
 * - Smooth 2D movement with acceleration/deceleration physics
 * - Client captures inputs and predicts movement locally (instant response)
 * - Inputs are buffered and sent to server with sequence numbers
 * - Server processes inputs authoritatively and broadcasts state
 * - Client reconciles predicted state with server state, replaying unacked inputs
 */

// Import default template files as raw strings from templates/sandbox-player-movement-netcode/
import sharedTypesCode from '../../templates/sandbox-player-movement-netcode/shared/types.ts?raw';
import sharedConstantsCode from '../../templates/sandbox-player-movement-netcode/shared/constants.ts?raw';
import playerMovementComponentCode from '../../templates/sandbox-player-movement-netcode/shared/components/PlayerMovementComponent.ts?raw';
import playerEntityCode from '../../templates/sandbox-player-movement-netcode/shared/entities/Player.ts?raw';
import clientTypesCode from '../../templates/sandbox-player-movement-netcode/client/types.ts?raw';
import inputSystemCode from '../../templates/sandbox-player-movement-netcode/client/systems/InputSystem.ts?raw';
import predictionSystemCode from '../../templates/sandbox-player-movement-netcode/client/systems/PredictionSystem.ts?raw';
import playerSyncSystemCode from '../../templates/sandbox-player-movement-netcode/client/systems/PlayerSyncSystem.ts?raw';
import renderSystemCode from '../../templates/sandbox-player-movement-netcode/client/systems/RenderSystem.ts?raw';
import playerManagerSystemCode from '../../templates/sandbox-player-movement-netcode/server/systems/PlayerManagerSystem.ts?raw';
import serverMovementSystemCode from '../../templates/sandbox-player-movement-netcode/server/systems/ServerMovementSystem.ts?raw';
import playerMovementSpecCode from '../../templates/sandbox-player-movement-netcode/shared/__tests__/PlayerMovement.spec.ts?raw';
import playerMovementMultiClientSpecCode from '../../templates/sandbox-player-movement-netcode/shared/__tests__/PlayerMovementMultiClient.spec.ts?raw';
import testApiMetaSpecCode from '../../templates/sandbox-player-movement-netcode/shared/__tests__/TestApiMeta.spec.ts?raw';
import { SandboxTemplate } from './types';


export const playerMovementSystem: SandboxTemplate = {
  name: 'Player Movement Netcode',
  description: 'A sandbox template demonstrating client-side prediction with server reconciliation for smooth player movement using netcode.',
  systems: {
    shared: {
      rootFiles: [
        { name: 'types', code: sharedTypesCode },
        { name: 'constants', code: sharedConstantsCode },
      ],
      subfolders: {
        components: [
          { name: 'PlayerMovementComponent', code: playerMovementComponentCode },
        ],
        entities: [
          { name: 'Player', code: playerEntityCode },
        ],
        __tests__: [
          { name: 'PlayerMovement.spec', code: playerMovementSpecCode },
          { name: 'PlayerMovementMultiClient.spec', code: playerMovementMultiClientSpecCode },
          { name: 'TestApiMeta.spec', code: testApiMetaSpecCode },
        ],
      },
    },
    client: {
      rootFiles: [
        { name: 'types', code: clientTypesCode },
      ],
      subfolders: {
        systems: [
          { name: 'InputSystem', code: inputSystemCode },
          { name: 'PlayerSyncSystem', code: playerSyncSystemCode },
          { name: 'PredictionSystem', code: predictionSystemCode },
          { name: 'RenderSystem', code: renderSystemCode },
        ],
        components: [],
        entities: [],
      },
    },
    server: {
      rootFiles: [],
      subfolders: {
        systems: [
          { name: 'PlayerManagerSystem', code: playerManagerSystemCode },
          { name: 'ServerMovementSystem', code: serverMovementSystemCode },
        ],
        components: [],
        entities: [],
      },
    },
  }
};